export default class CreateCommitteeCtrl {

	constructor($scope, GeneralSettingsSrv, $mdDialog, $interval, uiGridConstants, i18nService, $state, $timeout, $cookies, Validations, GlobalConfig, GlobalSrv, ngNotify) {
		i18nService.setCurrentLang('es')

		// constants
		const createCommitteeVM = this
		const user = JSON.parse($cookies.get('currentUser'))
		const currentRoleId = JSON.parse($cookies.get('hasRoleId'))

		createCommitteeVM.submodules = {}
		createCommitteeVM.users = {}
		createCommitteeVM.minStartDate = moment().toDate()

		// variables
		createCommitteeVM.usersFilter = ''
		createCommitteeVM.searchBy = '1'
		createCommitteeVM.searchAdminBy = '1'
		createCommitteeVM.selectedUser = ''
		createCommitteeVM.newCommittee = ''
		createCommitteeVM.committeeUsers = []
		createCommitteeVM.committeeAdminUser = {}
		createCommitteeVM.mappedUsers = []
		createCommitteeVM.selectedTeachers = []
		createCommitteeVM.mappedTeachers = []
		createCommitteeVM.isDisabled = false
		createCommitteeVM.startDate = null
		createCommitteeVM.endDate = null
		createCommitteeVM.selectedSubmodules = []
		createCommitteeVM.mappedSubmodules = []
		createCommitteeVM.minEndDate = moment().toDate()

		// methods
		createCommitteeVM.searchUsers = searchUsers
		createCommitteeVM.highlightFilteredHeader = highlightFilteredHeader
		createCommitteeVM.filter = filter
		createCommitteeVM.singleFilter = singleFilter
		createCommitteeVM.toggle = toggle
		createCommitteeVM.exists = exists
		createCommitteeVM.isIndeterminate = isIndeterminate
		createCommitteeVM.isChecked = isChecked
		createCommitteeVM.toggleAll = toggleAll
		createCommitteeVM.addUserToCommittee = addUserToCommittee
		createCommitteeVM.addAdminUsertoComittee = addAdminUsertoComittee
		createCommitteeVM.dropUser = dropUser
		createCommitteeVM.dropAdminUser = dropAdminUser
		createCommitteeVM.validateForm = validateForm
		createCommitteeVM.saveCommitteeConfig = saveCommitteeConfig
		createCommitteeVM.startDateChanged = startDateChanged
		createCommitteeVM.hasError = hasError
		createCommitteeVM.showErrorMessages = showErrorMessages

		// grid object configuration
		createCommitteeVM.committeeGrid = {
			enableRowHeaderSelection: true,
			enableRowSelection      : true,
			enableSelectAll         : false,
			showGridFooter          : true,
			selectionRowHeaderWidth : 35,
			rowHeight               : 35,
			enableFiltering         : true,
			multiSelect             : true,
			columnDefs              : [
				{
					name            : 'Nombre',
					displayName     : 'Nombre',
					field           : 'teacherName',
					width           : '30%',
					headerCellClass : createCommitteeVM.highlightFilteredHeader,
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				}, {
					name            : 'Unidad académica',
					displayName     : 'Unidad académica',
					field           : 'academicUnitName',
					width           : '35%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				}, {
					name            : 'Cédula',
					displayName     : 'Cédula',
					field           : 'identification',
					width           : '25%',
					enableGridMenu  : false,
					enableHiding    : false,
					enablePinning   : false,
					enableColumnMenu: false,
					enableSorting   : false,
					cellClass       : 'text-xs',
					headerCellClass : 'font-normal text-xs',
				},
			],
			onRegisterApi: (gridApi) => {
				createCommitteeVM.gridApi = gridApi
				createCommitteeVM.gridApi.grid.registerRowsProcessor(createCommitteeVM.singleFilter, 200)
				gridApi.selection.on.rowSelectionChanged($scope, (row) => {
					if (createCommitteeVM.selectedTeachers.includes(row.entity.teacherId)) {
						let idx = createCommitteeVM.selectedTeachers.indexOf(row.entity.teacherId)

						createCommitteeVM.selectedTeachers.splice(idx, 1)
					} else {
						createCommitteeVM.selectedTeachers.push(row.entity.teacherId)
					}
				})
				$interval(() => {
					createCommitteeVM.gridApi.core.handleWindowResize()
				}, 500, 10)
			},
		}

		// methods declaration
		function activate() {
			return getCommitteeFormData()
		}

		function getCommitteeFormData() {
			let header = {}

			if (Validations.isAdminUnit(currentRoleId) || Validations.isGerencialConsultant(currentRoleId)) {
				header.userId = user.id
				header.rolId = currentRoleId
			}

			return GeneralSettingsSrv.getCommitteeFormData.get(header).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					createCommitteeVM.submodules = dataReturn.submodules
					createCommitteeVM.users = dataReturn.users
					createCommitteeVM.committeeGrid.data = dataReturn.teachers
				}
			}).catch((err) => {
				console.log(err)
			})
		}

		function getNotifyAdmin(rolesId) {
			getSendNotifyAdmin(rolesId)
		}

		function getSendNotifyAdmin(rolesId) {
			let data = {
				rolesId                     : rolesId,
				idTeacher                   : null,
				dsName                      : 'Notificación, se agregó un comité',
				dsDescription               : 'Administrador de unidad ó modulo: se ha creado el comité "' + createCommitteeVM.newCommittee + '" con las siguientes fechas de inicio: ' + moment(createCommitteeVM.startDate).format('DD/MM/YYYY') + ' y fin: ' + moment(createCommitteeVM.endDate).format('DD/MM/YYYY'),
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
				is_grouped                  : 1,
			}

			GlobalSrv.addNotificationToAdminWorkPlan.add(data).$promise.then((dataReturn) => {
				if (dataReturn.status) {
					console.log('Notificación exitosa', dataReturn)
				} else {
					console.log('Error de comunicación en la notificación')
				}
			}).catch((error) => {
				console.error(error)
			})
			//GlobalSrv.sendNotificationAdmin(data)
		}

		function getNotifyExceed(idRole) {
			let reviewers = GlobalSrv.getReviewers(idRole)

			reviewers.forEach((reviewer) => {
				getSendNotifyExceed(reviewer)
			})
		}

		function getSendNotifyExceed(idUser) {
			let data = {
				idUser                      : idUser,
				dsName                      : 'Notificación, se agregó un comité que excede los lineamientos institucionales',
				dsDescription               : 'Sr. Administrador de unidad, el comité "' + createCommitteeVM.newCommittee + '" que editó excede los lineamientos institucionales, se modificaron as fechas de inicio: ' + moment(createCommitteeVM.startDate).format('DD/MM/YYYY') + ' y fin: ' + moment(createCommitteeVM.endDate).format('DD/MM/YYYY'),
				idNotification_delivery_type: GlobalConfig.notificationType.inbox,
			}

			console.log('getSendNotifyExceed--->', data)
			GlobalSrv.sendNotification(data)
		}

		function addCommittee(params) {
			return GeneralSettingsSrv.addCommittee.post(params).$promise.then((dataReturn) => {
				if (dataReturn.status === true) {
					//Notificación excede
					//getNotifyExceed(GlobalConfig.userRolesIds.adminUnit)
					getNotifyAdmin([ GlobalConfig.userRolesIds.generalAdmin, GlobalConfig.userRolesIds.workPlanAdmin, GlobalConfig.userRolesIds.adminUnit, GlobalConfig.userRolesIds.adminModule ])

					$state.go('generalSettings.users')
				} else {
					console.log(dataReturn)
					createCommitteeVM.isDisabled = false
					ngNotify.set('No se ha podido conectar con el servicio', 'error')
				}
			}).catch((err) => {
				createCommitteeVM.isDisabled = false
				console.log(err)
				ngNotify.set('No se ha podido conectar con el servicio', 'error')
			})
		}

		function searchUsers(text) {
			let matcher = new RegExp(text, 'i')
			let arr = []

			createCommitteeVM.users.forEach((user) => {
				if (createCommitteeVM.searchBy === '1') {
					if (user.ds_fullname.match(matcher)) {
						arr.push(user)
					}
				} else {
					if (user.ds_identification.match(matcher)) {
						arr.push(user)
					}
				}
			})

			return arr
		}

		function highlightFilteredHeader(row, rowRenderIndex, col, colRenderIndex) {
			if (col.filters[0].term) {
				return 'header-filtered'
			} else {
				return ''
			}
		}

		function filter() {
			createCommitteeVM.gridApi.grid.refresh()
		}

		function singleFilter(renderableRows) {
			var matcher = new RegExp(createCommitteeVM.usersFilter, 'i')

			renderableRows.forEach((row) => {
				var match = false;

				[ 'teacherName', 'academicUnitName', 'identification' ].forEach((field) => {
					if (row.entity[field].match(matcher)) {
						match = true
					}
				})

				if (!match) {
					row.visible = false
				}
			})

			return renderableRows
		}

		function toggle(item) {
			let idx = createCommitteeVM.selectedSubmodules.indexOf(item)

			if (idx > -1) {
				createCommitteeVM.selectedSubmodules.splice(idx, 1)
			} else {
				createCommitteeVM.selectedSubmodules.push(item)
			}

			createCommitteeVM.mappedSubmodules = createCommitteeVM.selectedSubmodules.map((submodule) => {
				return { submoduleId: submodule.id_code }
			})
		}

		function exists(item) {
			return createCommitteeVM.selectedSubmodules.indexOf(item) > -1
		}

		function isIndeterminate() {
			return (createCommitteeVM.selectedSubmodules.length !== 0 && createCommitteeVM.selectedSubmodules.length !== createCommitteeVM.submodules.length)
		}

		function isChecked() {
			return createCommitteeVM.selectedSubmodules.length === createCommitteeVM.submodules.length
		}

		function toggleAll() {
			if (createCommitteeVM.selectedSubmodules.length === createCommitteeVM.submodules.length) {
				createCommitteeVM.selectedSubmodules = []
				createCommitteeVM.mappedSubmodules = []
			} else if (createCommitteeVM.selectedSubmodules.length === 0 || createCommitteeVM.selectedSubmodules.length > 0) {
				createCommitteeVM.selectedSubmodules = createCommitteeVM.submodules.slice(0)
				createCommitteeVM.mappedSubmodules = createCommitteeVM.submodules.slice(0).map((submodule) => {
					return { submoduleId: submodule.id_code }
				})
			}
		}

		function addUserToCommittee(user) {
			if (user && !createCommitteeVM.committeeUsers.includes(user)) {
				createCommitteeVM.committeeUsers.push(user)
				createCommitteeVM.mappedUsers.push({ userId: user.id_code })
			}

			createCommitteeVM.searchText = ''
		}
		function addAdminUsertoComittee(user) {
			if (user && createCommitteeVM.committeeAdminUser !== user) {
				createCommitteeVM.committeeAdminUser = user
			}

			createCommitteeVM.searchAdminText = ''
		}

		function dropUser(idx) {
			createCommitteeVM.committeeUsers.splice(idx, 1)
			createCommitteeVM.mappedUsers.splice(idx, 1)
		}
		function dropAdminUser() {
			createCommitteeVM.committeeAdminUser = {}
		}

		function saveCommitteeConfig() {
			createCommitteeVM.isDisabled = true
			createCommitteeVM.selectedTeachers = createCommitteeVM.selectedTeachers.map((id) => {
				return { teacherId: id }
			})
			let params = {
				comiteeAdminUser: createCommitteeVM.committeeAdminUser.id_code || null,
				roleId          : 4,
				comiteeName     : createCommitteeVM.newCommittee,
				comiteeTypeId   : 1,
				startDate       : moment(new Date(createCommitteeVM.startDate)).format('YYYY-MM-DD hh:mm:ss'),
				endDate         : moment(new Date(createCommitteeVM.endDate)).format('YYYY-MM-DD hh:mm:ss'),
				users           : createCommitteeVM.mappedUsers,
				submodules      : createCommitteeVM.mappedSubmodules,
				teachers        : createCommitteeVM.selectedTeachers,
			}

			addCommittee(params)
		}

		function startDateChanged() {
			let m = moment(createCommitteeVM.startDate)

			createCommitteeVM.minEndDate = m.isValid() ? m.add(1, 'days').toDate() : moment().toDate()
		}

		function hasError(input) {
			if (input.$invalid && (input.$dirty || input.$touched))
				return 'has-error'
		}

		function showErrorMessages(input) {
			return input.$dirty || input.$touched
		}

		function validateForm() {

		}

		// initialization
		activate()
	}//FIN DEL CONSTRUCTOR

	preventInput(event) {
		var vKey = 86

		if (event.keyCode == vKey)
			event.preventDefault()

		return
	}

}

CreateCommitteeCtrl.$inject = [ '$scope', 'GeneralSettingsSrv', '$mdDialog', '$interval', 'uiGridConstants', 'i18nService', '$state', '$timeout', '$cookies', 'Validations', 'GlobalConfig', 'GlobalSrv', 'ngNotify' ]



// WEBPACK FOOTER //
// ./src/app/u-faculty/generalSettings/users/create/createCommitteeCtrl.js